export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.46.0-a74e71f86.svg#cart-with-plus","viewBox":"0 0 48 48"}